if (!global._babelPolyfill && global._tcShouldPolyfill !== false) {
  require('./utils/polyfills')
} else {
  require('./utils/check-polyfills')
}

const NODE_TARGET = process.env.NODE_TARGET || 'node'
require(`./platform-specific/${NODE_TARGET}`)

const { TigerConnectClient } = require('./Client')

export const Client = TigerConnectClient
